import { NEW_USER_TOKEN, FETCH_USER_INFO, FETCH_USER_INFO_DONE, FETCH_USER_INFO_ERR, LOGIN_USER, LOGIN_USER_DONE, LOGIN_USER_ERR, LOGOUT_USER, GET_USER_STATUS, GET_USER_STATUS_DONE, GET_USER_STATUS_ERR, GET_OWNER_STATUS, GET_OWNER_STATUS_DONE, GET_OWNER_STATUS_ERR, DELETE_USER, DELETE_USER_DONE, DELETE_USER_ERROR, REMOVE_USER_ERROR, MEMBERSHIP_PAYMENT_FAILED_MODAL_VIEWED, GET_NEW_USER_STATUS, HERO_FILL_ACTIVATED, NEW_ANONYMOUS_TOKEN, SELECT_HERO_ACCOUNT } from './actionTypes';
export const newUserToken = (data) => ({ type: NEW_USER_TOKEN, data });
export const fetchUserInfo = (data) => ({ type: FETCH_USER_INFO, data });
export const doneFetchUserInfo = (data) => ({
    type: FETCH_USER_INFO_DONE,
    data
});
export const errorFetchUserInfo = (data) => ({
    type: FETCH_USER_INFO_ERR,
    data
});
export const loginUser = (data) => ({ type: LOGIN_USER, data });
export const doneLogin = (data) => ({ type: LOGIN_USER_DONE, data });
export const errorLogin = (data) => ({ type: LOGIN_USER_ERR, data });
export const logoutUser = () => ({ type: LOGOUT_USER });
export const getUserStatus = () => ({ type: GET_USER_STATUS });
export const doneGettingUserStatus = (data) => ({
    type: GET_USER_STATUS_DONE,
    data
});
export const errorGettingUserStatus = (data) => ({
    type: GET_USER_STATUS_ERR,
    data
});
export const getOwnerStatus = () => ({ type: GET_OWNER_STATUS });
export const doneGettingOwnerStatus = (data) => ({
    type: GET_OWNER_STATUS_DONE,
    data
});
export const errorGettingOwnerStatus = (data) => ({
    type: GET_OWNER_STATUS_ERR,
    data
});
export const deleteUser = (data) => ({ type: DELETE_USER, data });
export const doneDeletingUser = () => ({ type: DELETE_USER_DONE });
export const errorDeletingUser = (data) => ({ type: DELETE_USER_ERROR, data });
export const removeUserError = () => ({ type: REMOVE_USER_ERROR });
export const membershipPaymentFailedModalViewed = () => ({
    type: MEMBERSHIP_PAYMENT_FAILED_MODAL_VIEWED
});
export const getNewUserStatus = (data) => ({ type: GET_NEW_USER_STATUS, data });
export const heroFillActivated = () => ({
    type: HERO_FILL_ACTIVATED
});
export const newAnonymousToken = (data) => ({ type: NEW_ANONYMOUS_TOKEN, data });
export const selectHeroAccount = (data) => ({ type: SELECT_HERO_ACCOUNT, data });
//# sourceMappingURL=actionCreators.js.map